<template>
  <v-scale-transition>
    <AppBtn
      v-if="visible"
      class="button"
      position="fixed"
      size="small"
      prepend-icon="mdi:archive-edit-outline"
      primary rounded
      @click="emit('click')"
    >
      {{ $tt(`back_to_form_${country}`) }}
    </AppBtn>
  </v-scale-transition>
</template>

<script setup lang="ts">
import { countryKeyInjectionKey } from '~/assets/injection-keys';

const emit = defineEmits(['click']);

defineProps<{
  visible: boolean;
}>();

const country = inject(countryKeyInjectionKey)!;
</script>

<style scoped>
.button {
  z-index: 5;
  inset-block-end: 20px;
  inset-inline-start: 20px;
}
</style>